var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"validate-container"},[_c('b-row',[_c('b-col',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem","margin-top":"15%"},attrs:{"label":"Large Spinner","type":"grow","variant":"secondary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }